import { Route, Routes } from "react-router-dom";
import "./App.css";
import Inv from "./components/Pages/Inv";
import Pi from "./components/Pages/pi";
import InvNew from "./components/Pages/Invnew";
import Tax from "./components/Pages/Tax";
import Lead from "./components/Pages/Lead";
import InvactiveUser from "./components/Pages/InvactiveUser";
import Terms from "./components/Pages/Terms";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/:id/:year" element={<Inv />} />
        <Route path="/new/:id/:year" element={<InvNew />} />
        <Route path="/invtax/:id/:year" element={<Tax />} />
        <Route path="/pi/:id/:year" element={<Pi />} />
        <Route path="/lead/:leadId/:projectId" element={<Lead />} />
        <Route path="/inactive-users" element={<InvactiveUser />} />
        <Route path="/termsconditon" element={<Terms />} />
      </Routes>
    </div>
  );
}

export default App;
